import { signIn, getSession } from "@stores/slices/userSlice";
import { createAccount } from "@api/routes/customer-authen";
import { Gender } from "@interfaces/dto/user-data.dto";
import { useAppDispatch } from "@stores/store";
import { commonToast, errorToast } from "@utils/toast";
import PhoneInput from "react-phone-number-input/input";
import { Controller, useForm } from "react-hook-form";
import TabSelect from "./TabSelect";
import { useRouter } from "next/router";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { useState } from "react";
import { isWebview, receiveTokenLoginNative } from "@utils/webview.util";
import {
  CMS_TERMS_ROUTE_PATH,
  CMS_PRIVACY_POLICY_ROUTE_PATH,
} from "@const/route-paths.const";

export type RegisterInputs = {
  email: string;
  firstName: string;
  lastName: string;
  gender: Gender;
  dob: Date;
  isSubscribed: boolean;
  mobileNo: string;
  password: string;
  passwordConfirm: string;
};

const RegisterForm = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  // let resumePath: string = "";
  // if (router.isReady) {
  //   resumePath = router.query.r as string;
  // }

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const toggleConfirmPassword = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setError,
  } = useForm<RegisterInputs>();

  const handleFormSubmit = async (inputs: RegisterInputs) => {
    if (inputs.password !== inputs.passwordConfirm) {
      setError("passwordConfirm", {
        message: "รหัสผ่านไม่ตรงกับรหัสผ่านที่ยืนยัน",
      });
      return;
    }
    // register
    const { isOk, message } = await createAccount({
      customer: {
        email: inputs.email,
        firstname: inputs.firstName,
        lastname: inputs.lastName,
        gender: inputs.gender,
        dob: inputs.dob,
        extension_attributes: {
          is_subscribed: inputs.isSubscribed,
        },
        custom_attributes: {
          mobile_number: inputs.mobileNo,
          // mobile_number: inputs.mobileNo.replace("+66", "0"),
        },
      },
      password: inputs.password,
    });
    commonToast({ isOk, message });
    if (isOk) {
      const response = await dispatch(
        signIn({ username: inputs.email, password: inputs.password })
      );
      const fetchSess = await dispatch(getSession());
      if (
        response.meta.requestStatus === "rejected" &&
        fetchSess.payload === undefined
      ) {
        errorToast("ไม่สามารถเข้าสู่ระบบได้");
      } else {
        router.push("/");
        if (isWebview() && fetchSess.payload.token) {
          receiveTokenLoginNative(fetchSess.payload.token);
        }
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="form-register">
      <div className="row g-3">
        <div className="col-6">
          <div className="input-group">
            <input
              {...register("firstName", { required: "โปรดกรอกชื่อ" })}
              type="text"
              className="form-control"
              placeholder="ชื่อ"
              aria-label="ชื่อ"
            />
            {errors.firstName && (
              <div className="invalid-feedback input-error">
                {errors.firstName.message}
              </div>
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="input-group">
            <input
              {...register("lastName", { required: "โปรดกรอกนามสกุล" })}
              type="text"
              className="form-control"
              placeholder="นามสกุล"
              aria-label="นามสกุล"
            />
            {errors.lastName && (
              <div className="invalid-feedback input-error">
                {errors.lastName.message}
              </div>
            )}
          </div>
        </div>
        <div className="col-12">
          <select
            className="form-select"
            {...register("gender", { required: true, valueAsNumber: true })}
          >
            {/* <option selected>เพศ</option> */}
            <option value={1}>ชาย</option>
            <option value={2}>หญิง</option>
          </select>
        </div>
        <div className="col-12">
          <div className="input-group">
            <input
              {...register("dob", {
                required: "โปรดกรอกวันเดือนปีเกิด",
              })}
              type="date"
              className="form-control"
              placeholder="วว-ดด-ปปปป"
            />
            {errors.dob && (
              <div className="invalid-feedback input-error">
                {errors.dob.message}
              </div>
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="input-group has-validation">
            <input
              {...register("email", { required: "โปรดกรอกอีเมล" })}
              type="email"
              className="form-control"
              placeholder="อีเมล"
            />
            {errors.email && (
              <div className="invalid-feedback input-error">
                {errors.email.message}
              </div>
            )}
          </div>
        </div>
        <div className="col-12">
          {/* <div className="input-group has-validation">
            <Controller
              control={control}
              name="mobileNo"
              rules={{ required: "โปรดกรอกเบอร์โทรศัพท์" }}
              render={({ field: { onChange, value } }) => (
                <PhoneInput
                  className="form-control"
                  country="TH"
                  value={value}
                  onChange={onChange}
                  placeholder="เบอร์โทรศัพท์"
                />
              )}
            />
            {errors.mobileNo && (
              <div className="invalid-feedback input-error">
                {errors.mobileNo.message}
              </div>
            )}
          </div> */}
          <div className="input-group">
            <input
              {...register("mobileNo", {
                required: "โปรดกรอกเบอร์โทรศัพท์",
                pattern: {
                  value: /^\(?([0-9]{3})\)?([0-9]{3})?([0-9]{4})$/,
                  message: "เบอร์โทรศัพท์ไม่ถูกต้อง",
                },
              })}
              type="text"
              className="form-control"
              placeholder="เบอร์โทรศัพท์"
              aria-label="เบอร์โทรศัพท์"
              autoComplete="off"
            />
            {errors.mobileNo && (
              <div className="invalid-feedback input-error">
                {errors.mobileNo.message}
              </div>
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="input-group">
            <input
              {...register("password", { required: "โปรดกรอกรหัสผ่าน" })}
              type={passwordShown ? "text" : "password"}
              className="form-control"
              placeholder="รหัสผ่าน"
            />
            <span className="input-group-text" onClick={togglePassword}>
              {passwordShown ? <Eye /> : <EyeSlash />}
            </span>
            {errors.password && (
              <div className="invalid-feedback input-error">
                {errors.password.message}
              </div>
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="input-group">
            <input
              {...register("passwordConfirm", {
                required: "โปรดกรอกยืนยันรหัสผ่าน",
              })}
              type={confirmPasswordShown ? "text" : "password"}
              className="form-control"
              placeholder="ยืนยันรหัสผ่าน"
            />
            <span className="input-group-text" onClick={toggleConfirmPassword}>
              {confirmPasswordShown ? <Eye /> : <EyeSlash />}
            </span>
            {errors.passwordConfirm && (
              <div className="invalid-feedback input-error">
                {errors.passwordConfirm.message}
              </div>
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input
              {...register("isSubscribed")}
              className="form-check-input"
              type="checkbox"
              id="gridCheck1"
            />
            <label className="form-check-label" htmlFor="gridCheck1">
              ฉันต้องการได้รับการแจ้งเตือนโปรโมชั่นของ <span>Top</span>
              <span>value</span>
            </label>
          </div>
        </div>
        <div className="d-grid">
          <button
            type="submit"
            className="btn btn-block btn-red"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Please wait..." : "ลงทะเบียน"}
          </button>
        </div>
        <div className="col-12 text-center">
          <p className="form-check-label mb-0">
            ฉันตกลงตาม
            <a
              href={CMS_TERMS_ROUTE_PATH}
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark"
            >
              ข้อกำหนดและเงื่อนไข
            </a>
            <br />
            และรับทราบ
            <a
              href={CMS_PRIVACY_POLICY_ROUTE_PATH}
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark"
            >
              นโยบายความเป็นส่วนตัว
            </a>
          </p>
        </div>
      </div>
    </form>
  );
};

export default RegisterForm;
